import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '../../../shared/services/user/user.service';
import { FormArray, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomValidators } from "../../../reset-password/custom-validators";

declare var $: any;

@Component({
    selector: 'app-jockey-valet',
    templateUrl: './jockey-valet.component.html',
    styleUrls: ['./jockey-valet.component.scss']
})
export class JockeyValetComponent implements OnInit, OnDestroy {
    token = localStorage.getItem('token');
    jockeyValet: FormGroup;
    licenceFees: FormGroup;
    assistantList: FormArray;
    editing = true;
    loading = false;
    submitted = false;
    riderList: any;
    today: number = Date.now();
    files: File[] = [];
    filesToUpload: File[] = [];
    fileExists = false;
    person = JSON.parse(localStorage.getItem('person'));
    checkSubmitApplication = false;
    isRenewalApplication = false;
    errorMessage: any;
    notvalidate = false;
    currentApplicationDetails: any;
    licenceFeesList: any;
    confirmLicenceFeesStatus: any;
    totalFees = 0;
    isAddRider = false;

    applicationFeesList: any;
    feeForm: FormGroup;
    constructor(public router: Router,
        private toastr: ToastrService,
        private formBuilder: FormBuilder,
        private userService: UserService,
        private spinner: NgxSpinnerService) {
    }

    ngOnInit() {
        this.userService.setCurrentLicenceType();
        this.currentApplicationDetails = this.userService.getCurrentLicenceType();
        if (this.currentApplicationDetails.licenceType === 'Jockey Valet') {
            if (this.currentApplicationDetails.isRenewLicensingApplication === true) {
                this.isRenewalApplication = true;
            } else {
                this.isRenewalApplication = false;
            }
            this.enableApplication();
            this.riderListData();
            this.getJockeyAgentApplicationData();
        }
    }

    enableApplication() {
        if (this.currentApplicationDetails.isLicensingApplicationSubmitted === true) {
            this.checkSubmitApplication = true;
        }
    }

    getJockeyAgentApplicationData() {
        this.spinner.show();
        this.userService.getJockeyAgentValetApplicationService(this.token).subscribe((data: any) => {
            this.spinner.hide();
            if (this.isRenewalApplication === false) {
                this.createForm(data);
            } else {
                this.createRenewForm(data);
            }
            this.feeForm = this.formBuilder.group({
                licenceType: [data.data.person.licenceType],
                totalFee: [data.totalFee]
            });
            this.applicationFeesList = data;
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    createForm(data) {
        data = data.data;
        if (data.person.nokPhone === null || data.fitAndProperPerson === null || data.declaration === null) {
            this.jockeyValet = this.formBuilder.group({
                person: this.formBuilder.group({
                    title: [data.person.title],
                    firstName: [data.person.firstName],
                    middleName: [data.person.middleName],
                    surname: [data.person.surname],
                    dateOfBirth: [data.person.dateOfBirth],
                    gender: [data.person.gender],
                    email: [data.person.email],
                    addressLine1: [data.person.addressLine1],
                    addressLine2: [data.person.addressLine2],
                    addressLine3: [data.person.addressLine3],
                    county: [data.person.county],
                    country: [data.person.country],
                    eircode: [data.person.eircode],
                    phoneNumber: [data.person.phoneNumber],
                    middlePhoneNumber: [data.person.middlePhoneNumber],
                    phoneCountryCode: [data.person.phoneCountryCode],
                    mobilePhoneNumber: [data.person.mobilePhoneNumber],
                    middleMobilePhoneNumber: [data.person.middleMobilePhoneNumber],
                    mobileCountryCode: [data.person.mobileCountryCode],
                    application: this.formBuilder.group({
                        nextOfKin: ['', [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\- ][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.]*)*$'), Validators.minLength(2)]],
                        nokPhoneCode: ['', Validators.required],
                        middleNokPhone: ['', [Validators.required, Validators.pattern('^0[0-9]\\d{0,5}')]],
                        nokPhone: ['', [Validators.required, Validators.pattern('[0-9]\\d{6,11}')]],
                    })
                }),
                jockeyValetAssistantList: this.formBuilder.array([]),
                fitAndProperPerson: this.formBuilder.group({
                    hadBankrupt: [false],
                    bankruptDetails: ['', [Validators.required, Validators.maxLength(2000)]],
                    anyDisqualification: [false],
                    disqualificationDetails: ['', [Validators.required, Validators.maxLength(2000)]],
                    experienceDetails: ['', [Validators.required, Validators.maxLength(2000)]],
                }),
                agentRiderList: this.formBuilder.array([]),
                declaration: this.formBuilder.group({
                    declarationAcknowledgement: [false, Validators.requiredTrue]
                })
            }, { validator: CustomValidators.prototype.nokValidationForAgentValet });
            this.subscribeYesNoToggle();
        } else {
            this.jockeyValet = this.formBuilder.group({
                person: this.formBuilder.group({
                    id: [data.person.id],
                    title: [data.person.title],
                    firstName: [data.person.firstName],
                    middleName: [data.person.middleName],
                    surname: [data.person.surname],
                    dateOfBirth: [data.person.dateOfBirth],
                    gender: [data.person.gender],
                    email: [data.person.email],
                    addressLine1: [data.person.addressLine1],
                    addressLine2: [data.person.addressLine2],
                    addressLine3: [data.person.addressLine3],
                    county: [data.person.county],
                    country: [data.person.country],
                    eircode: [data.person.eircode],
                    phoneNumber: [data.person.phoneNumber],
                    middlePhoneNumber: [data.person.middlePhoneNumber],
                    phoneCountryCode: [data.person.phoneCountryCode],
                    mobilePhoneNumber: [data.person.mobilePhoneNumber],
                    middleMobilePhoneNumber: [data.person.middleMobilePhoneNumber],
                    mobileCountryCode: [data.person.mobileCountryCode],
                    application: this.formBuilder.group({
                        nextOfKin: [data.person.application.nextOfKin, [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\- ][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.]*)*$'), Validators.minLength(2)]],
                        nokPhoneCode: [data.person.application.nokPhoneCode, Validators.required],
                        middleNokPhone: [data.person.application.middleNokPhone, [Validators.required, Validators.pattern('^0[0-9]\\d{0,5}')]],
                        nokPhone: [data.person.application.nokPhone, [Validators.required, Validators.pattern('[0-9]\\d{6,11}')]],
                    })
                }),
                jockeyValetAssistantList: this.formBuilder.array([]),
                fitAndProperPerson: this.formBuilder.group({
                    id: [data.fitAndProperPerson.id],
                    hadBankrupt: [data.fitAndProperPerson.hadBankrupt],
                    bankruptDetails: [data.fitAndProperPerson.bankruptDetails, [Validators.required, Validators.maxLength(2000)]],
                    anyDisqualification: [data.fitAndProperPerson.anyDisqualification],
                    disqualificationDetails: [data.fitAndProperPerson.disqualificationDetails, [Validators.required, Validators.maxLength(2000)]],
                    experienceDetails: [data.fitAndProperPerson.experienceDetails, [Validators.required, Validators.maxLength(2000)]],
                }),
                agentRiderList: this.formBuilder.array([]),
                declaration: this.formBuilder.group({
                    id: [data.declaration.id],
                    declarationAcknowledgement: [data.declaration.declarationAcknowledgement, Validators.requiredTrue]
                })
            }, { validator: CustomValidators.prototype.nokValidationForAgentValet });
            this.subscribeYesNoToggle();
            this.patchAddRider(data);
            this.patchAssistant(data);
        }
        this.assistantList = this.jockeyValet.get('jockeyValetAssistantList') as FormArray;
    }

    createRenewForm(data) {
        data = data.data;
        if (data.person.renewNokPhone === null || data.declaration === null) {
            this.jockeyValet = this.formBuilder.group({
                person: this.formBuilder.group({
                    title: [data.person.title],
                    firstName: [data.person.firstName],
                    middleName: [data.person.middleName],
                    surname: [data.person.surname],
                    dateOfBirth: [data.person.dateOfBirth],
                    gender: [data.person.gender],
                    email: [data.person.email],
                    addressLine1: [data.person.addressLine1],
                    addressLine2: [data.person.addressLine2],
                    addressLine3: [data.person.addressLine3],
                    county: [data.person.county],
                    country: [data.person.country],
                    eircode: [data.person.eircode],
                    phoneNumber: [data.person.phoneNumber],
                    middlePhoneNumber: [data.person.middlePhoneNumber],
                    phoneCountryCode: [data.person.phoneCountryCode],
                    mobilePhoneNumber: [data.person.mobilePhoneNumber],
                    middleMobilePhoneNumber: [data.person.middleMobilePhoneNumber],
                    mobileCountryCode: [data.person.mobileCountryCode],
                    application: this.formBuilder.group({
                        nextOfKin: ['', [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\- ][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.]*)*$'), Validators.minLength(2)]],
                        nokPhoneCode: ['', Validators.required],
                        middleNokPhone: ['', [Validators.required, Validators.pattern('^0[0-9]\\d{0,5}')]],
                        nokPhone: ['', [Validators.required, Validators.pattern('[0-9]\\d{6,11}')]],
                    })
                }),
                jockeyValetAssistantList: this.formBuilder.array([]),
                declaration: this.formBuilder.group({
                    declarationAcknowledgement: [false, Validators.requiredTrue]
                })
            }, { validator: CustomValidators.prototype.nokValidationForAgentValet });
        } else {
            this.jockeyValet = this.formBuilder.group({
                person: this.formBuilder.group({
                    id: [data.person.id],
                    title: [data.person.title],
                    firstName: [data.person.firstName],
                    middleName: [data.person.middleName],
                    surname: [data.person.surname],
                    dateOfBirth: [data.person.dateOfBirth],
                    gender: [data.person.gender],
                    email: [data.person.email],
                    addressLine1: [data.person.addressLine1],
                    addressLine2: [data.person.addressLine2],
                    addressLine3: [data.person.addressLine3],
                    county: [data.person.county],
                    country: [data.person.country],
                    eircode: [data.person.eircode],
                    phoneNumber: [data.person.phoneNumber],
                    middlePhoneNumber: [data.person.middlePhoneNumber],
                    phoneCountryCode: [data.person.phoneCountryCode],
                    mobilePhoneNumber: [data.person.mobilePhoneNumber],
                    middleMobilePhoneNumber: [data.person.middleMobilePhoneNumber],
                    mobileCountryCode: [data.person.mobileCountryCode],
                    application: this.formBuilder.group({
                        nextOfKin: [data.person.application.nextOfKin, [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\- ][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.]*)*$'), Validators.minLength(2)]],
                        nokPhoneCode: [data.person.application.nokPhoneCode, Validators.required],
                        middleNokPhone: [data.person.application.middleNokPhone, [Validators.required, Validators.pattern('^0[0-9]\\d{0,5}')]],
                        nokPhone: [data.person.application.nokPhone, [Validators.required, Validators.pattern('[0-9]\\d{6,11}')]],
                    })
                }),
                jockeyValetAssistantList: this.formBuilder.array([]),
                declaration: this.formBuilder.group({
                    id: [data.declaration.id],
                    declarationAcknowledgement: [data.declaration.declarationAcknowledgement, Validators.requiredTrue]
                })
            }, { validator: CustomValidators.prototype.nokValidationForAgentValet });
            this.patchAssistant(data);
        }
        this.assistantList = this.jockeyValet.get('jockeyValetAssistantList') as FormArray;
    }

    patchAddRider(data) {
        const control = <FormArray>this.jockeyValet.get('agentRiderList');
        if (data.agentRiderList.length > 0) {
            this.isAddRider = true;
            data.agentRiderList.forEach(x => {
                control.push(this.patchValueRider(x));
            });
        } else {
            this.isAddRider = false;
        }
    }
    patchValueRider(data) {
        return this.formBuilder.group({
            id: [data.id],
            ridername: [data.ridername],
            agentConfirmedStatus: [data.agentConfirmedStatus],
            notificationId: [data.notificationId],
        });
    }

    get assistantFormGroup() {
        return this.jockeyValet.get('jockeyValetAssistantList') as FormArray;
    }

    patchAssistant(data) {
        const controlAssistant = <FormArray>this.jockeyValet.get('jockeyValetAssistantList');
        if (data.jockeyValetAssistantList != null && data.jockeyValetAssistantList.length > 0) {
            data.jockeyValetAssistantList.forEach(x => {
                controlAssistant.push(this.patchValuesAssistant(x));
            });
        }
    }

    patchValuesAssistant(data) {
        return this.formBuilder.group({
            id: [data.id],
            longName: [data.longName, [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\- ][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.]*)*$'), Validators.minLength(2)]],
            dateOfBirth: [data.dateOfBirth],
            address: [data.address],
            partTimeOrFullTime: [data.partTimeOrFullTime],
            photo: [data.photo],
        });
    }

    assistantForm(data): FormGroup {
        if (data) {
            return this.formBuilder.group({
                id: [data.id],
                longName: [data.longName, [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\- ][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.]*)*$'), Validators.minLength(2)]],
                dateOfBirth: [data.dateOfBirth],
                address: [data.address],
                partTimeOrFullTime: [data.partTimeOrFullTime],
                photo: [data.photo],
            });
        } else {
            return this.formBuilder.group({
                id: [''],
                longName: ['', [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\- ][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.]*)*$'), Validators.minLength(2)]],
                dateOfBirth: ['', [Validators.required]],
                address: ['', [Validators.required]],
                partTimeOrFullTime: ['', [Validators.required]],
                photo: null,
            });
        }
    }

    addAssistant(data) {
        this.assistantList.push(this.assistantForm(data));
    }

    removeAssistantData(index) {
        this.assistantList.removeAt(index);
    }

    onFileChange(fileInput: any) {
        if (fileInput.target.files.length > 0) {
            this.fileCheck(fileInput);
            this.fileExists = true;
        }
    }

    fileCheck(fileInput) {
        this.files = [];
        let fileName;
        let totalsize = 0;
        this.notvalidate = false;
        for (let i = 0; i < fileInput.target.files.length; i++) {

            fileName = fileInput.target.files[i].name;
            let fileSize = fileInput.target.files[i].size;
            if (fileName != undefined || fileName != '') {
                totalsize += Number(fileSize);
            }
        }

        let maxsize = 50 * 1024 * 1024; // 50Mb
        if (totalsize > maxsize && this.notvalidate === false) {
            this.notvalidate = true;
            this.toastr.error(this.errorMessage);
        } else {
            this.filesToUpload = <Array<File>>fileInput.target.files;
            for (let i = 0; i < this.filesToUpload.length; i++) {
                this.files.push(fileInput.target.files[i]);
            }
        }
    }

    private prepareSaveFilesData(): any {
        let input: any = new FormData();
        for (var i = 0; i < this.filesToUpload.length; i++) {
            input.append('files', this.files[i], this.files[i].name);
        }
        input.append('fileExists', this.fileExists);
        return input;
    }
    submitFilesData(i) {
        const formModel = this.prepareSaveFilesData();
        this.spinner.show();
        this.userService.postJockeyValetFileDataService(this.token, formModel).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                this.jockeyValet.value.jockeyValetAssistantList[i].photo = data.data;
                this.toastr.success(data.message);
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    subscribeYesNoToggle() {
        const hadBankrupt = this.jockeyValet.get('fitAndProperPerson').value.hadBankrupt;
        if (hadBankrupt === false) {
            this.hadBankruptDisable();
            this.hadBankruptClick();
        } else if (hadBankrupt === true) {
            this.hadBankruptEnable();
            this.hadBankruptClick();
        }

        const anyDisqualification = this.jockeyValet.get('fitAndProperPerson').value.anyDisqualification;
        if (anyDisqualification === false) {
            this.anyDisqualificationDisable();
            this.anyDisqualificationClick();
        } else if (anyDisqualification === true) {
            this.anyDisqualificationEnable();
            this.anyDisqualificationClick();
        }
    }

    hadBankruptClick() {
        this.jockeyValet.get('fitAndProperPerson').get('hadBankrupt').valueChanges.subscribe(data => {
            if (data === true) {
                this.hadBankruptEnable();
            } else {
                this.hadBankruptDisable();
            }
        });
    }

    hadBankruptDisable() {
        this.jockeyValet.get('fitAndProperPerson').get('bankruptDetails').disable();
        this.jockeyValet.get('fitAndProperPerson').get('bankruptDetails').setValue('');
    }

    hadBankruptEnable() {
        this.jockeyValet.get('fitAndProperPerson').get('bankruptDetails').enable();
    }

    anyDisqualificationClick() {
        this.jockeyValet.get('fitAndProperPerson').get('anyDisqualification').valueChanges.subscribe(data => {
            if (data === true) {
                this.anyDisqualificationEnable();
            } else {
                this.anyDisqualificationDisable();
            }
        });
    }

    anyDisqualificationDisable() {
        this.jockeyValet.get('fitAndProperPerson').get('disqualificationDetails').disable();
        this.jockeyValet.get('fitAndProperPerson').get('disqualificationDetails').setValue('');
    }

    anyDisqualificationEnable() {
        this.jockeyValet.get('fitAndProperPerson').get('disqualificationDetails').enable();
    }


    number_keyPress(event: any) {
        const pattern = /[0-9]/;
        const inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    name_keyPress(event: any) {
        const pattern = /[a-z,A-Z]/;
        const inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    nameWithSpace_keyPress(event: any) {
        const pattern = /[a-z,A-Z\s]/;
        const inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    riderListData() {
        this.spinner.show();
        this.userService.getAddRiderService(this.token).subscribe((data: any) => {
            this.spinner.hide();
            this.riderList = data.data;
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    addRiderTrue() {
        this.isAddRider = true;
        var ridernamevalue = $('#riderId').val();
        if (ridernamevalue != null) {
            this.pushRider(ridernamevalue);
        }

    }

    addRider(email) {
        const riderList = this.riderList.find(x => x.email === email);
        const agentRider = this.jockeyValet.value.agentRiderList;
        if (agentRider.length === 0) {
            this.pushRider(riderList);
        } else {
            const data = agentRider.find(x => x.rider.email === email)
            if (!data) {
                this.pushRider(riderList);
            }
        }
    }

    pushRider(riderList) {
        this.jockeyValet.value.agentRiderList.push({ ridername: riderList, agentConfirmedStatus: 'Pending' });
        this.isAddRider = false;
    }


    deleteRiderData(index, rider) {
        if (rider.id) {
            this.spinner.show();
            this.userService.deleteRiderService(this.token, rider.id).subscribe((data: any) => {
                this.spinner.hide();
                if (data.status === true) {
                    this.toastr.success(data.message);
                } else {
                    this.toastr.error(data.message);
                }
            }, error => {
                if (error.status === 200) {
                    return;
                } else {
                    this.toastr.error(error.message);
                }
                this.spinner.hide();
            });
        }
        this.jockeyValet.value.agentRiderList.splice(index, 1);
        this.isAddRider = false;
    }

    postJockeyValetDataModal() {
        this.submitted = true;
        if (this.jockeyValet.invalid) {
            return;
        }
        this.loading = true;
        $('#postJockeyValetDataModal').modal('show');
    }

    submitJockeyValetData() {
        this.spinner.show();
        this.userService.postJockeyAgentValetApplicationService(this.token, this.jockeyValet.value).subscribe((data: any) => {
            this.spinner.hide();
            $('#postJockeyValetDataModal').modal('hide');
            if (data.status === true) {
                this.toastr.success(data.message);
                this.router.navigate(['/home']);
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    downloadFile(url) {
        window.open(url, "_blank");
    }

    ngOnDestroy() {
        $('#postJockeyValetDataModal').modal('hide');
    }

    addOptionFees(optionalFee, event) {
        let optionalFeeData = {id: optionalFee.id, isOptionalFee: event.target.checked};
        this.spinner.show();
        this.userService.postOptionalFeeService(this.token, this.currentApplicationDetails.licensingApplicationId, optionalFeeData).subscribe((data: any) => {
            this.spinner.hide();
            if(data.status === true) {
                this.toastr.success(data.message);
                this.getJockeyAgentApplicationData();
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    showRejectModel() {
        $('#rejectLicenceFeeModal').modal('show');
    }

    hideRejectLicenceFeeModal() {
        $('#rejectLicenceFeeModal').modal('hide');
    }

    confirmLicenceFees(status) {
        this.spinner.show();
        const data = { feesStatus: status };
        this.userService.postConfirmLicenceFeesService(this.token, this.currentApplicationDetails.licensingApplicationId, data).subscribe((data: any) => {
            this.spinner.hide();
            this.hideRejectLicenceFeeModal();
            if (data.status === true) {
                this.toastr.success(data.message);
                this.router.navigate(['/home']);
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }
}
